<div class="empty-state">
  <app-icon class="is-primary empty-state__image" iconName="empty-state"></app-icon>
  <ng-content></ng-content>
</div>
